$(document).ready(function () {
  function initConstructor(root) {
    const $root = $(root);
    const charmsPreview = $root.find('.constructor-step-2 .constructor-result-charms');
    const charmsTemplates = $root.find('.js-charms-templates');
    const startButton = $root.find('.js-constructor-start');
    const step1NextBtn = $root.find('.js-constructor-step1-next');
    const step2NextBtn = $root.find('.js-constructor-step2-next');
    const step2BackBtns = $root.find('.js-step-2-back-btn');
    const chainItems = $root.find('.js-chain-item');
    const charmsItems = $root.find('.js-charms-item');
    const MAX_CHARMS = 3;
    const chainPriceBlock = $root.find('.js-constructor-chain-price');
    const totalPriceBlock = $root.find('.js-constructor-total-price');

    let selectedCharmsCount = 0;
    let selectedChainVariantId = null;
    let chainPrice = 0;

    chainPriceBlock.text(chainPrice.toFixed(2));

    let charmsPrice = 0;
    let totalPriceText = (chainPrice + charmsPrice).toFixed(2);
    totalPriceBlock.text(totalPriceText);

    function renderPrice() {
      chainPriceBlock.text(chainPrice.toFixed(2));
      totalPriceText = (chainPrice + charmsPrice).toFixed(2);
      totalPriceBlock.text(totalPriceText);
    }

    function isChainAvailable($item) {
      return $item.attr('data-available') === 'true';
    }

    function syncSelectedChainState($target) {
      const targetCount = $target.attr('data-count');
      const variantId = $target.attr('data-variant-id');
      chainItems.removeClass('constructor-choice-item_active');
      $target.addClass('constructor-choice-item_active');
      $root.find('.constructor-result-chain').addClass('constructor-result-chain_hidden');
      $root.find('.constructor-result-chain[data-count="' + targetCount + '"]').removeClass('constructor-result-chain_hidden');
      selectedChainVariantId = variantId || null;
      chainPrice = parseFloat($target.attr('data-price')) || 0;
      renderPrice();
      step1NextBtn.prop('disabled', !selectedChainVariantId || !isChainAvailable($target));
    }

    function ensureValidChainSelection() {
      let $activeChainItem = $root.find('.js-chain-item.constructor-choice-item_active').first();

      if (!$activeChainItem.length || !isChainAvailable($activeChainItem)) {
        $activeChainItem = chainItems.filter(function () {
          return isChainAvailable($(this));
        }).first();
      }

      if ($activeChainItem.length) {
        syncSelectedChainState($activeChainItem);
      } else {
        chainItems.removeClass('constructor-choice-item_active');
        selectedChainVariantId = null;
        chainPrice = 0;
        $root.find('.constructor-result-chain').addClass('constructor-result-chain_hidden');
        renderPrice();
        step1NextBtn.prop('disabled', true);
      }
    }

    function showStep(step) {
      $root.find('.js-constructor-step').hide();
      $root.find('.js-constructor-step[data-constructor-step="' + step + '"]').css('display', 'flex');
      window.scrollTo(0, 0);
    }

    function changeCurrentChain() {
      const target = $(this);

      if (!isChainAvailable(target)) {
        return;
      }

      syncSelectedChainState(target);
    }

    function changeCurrentCharm() {
      const target = $(this);
      const targetCount = target.attr('data-count');
      const isAvailable = target.attr('data-available') === 'true';

      if (!isAvailable && !target.hasClass('constructor-choice-item_active')) {
        return;
      }

      if (target.hasClass('constructor-choice-item_active')) {
        selectedCharmsCount--;
        target.removeClass('constructor-choice-item_active');
        charmsPreview.find('.constructor-result-charm[data-count="' + targetCount + '"]').remove();
        charmsPrice = charmsPrice - (parseFloat(target.attr('data-price')) || 0);
        const count = charmsPreview.find('.constructor-result-charm').length;
        charmsPreview.removeClass('constructor-result-charms-1 constructor-result-charms-2 constructor-result-charms-3');
        charmsPreview.addClass('constructor-result-charms-' + count);
      } else {
        if (selectedCharmsCount < MAX_CHARMS) {
          selectedCharmsCount++;
          target.addClass('constructor-choice-item_active');
          charmsTemplates.find('.constructor-result-charm[data-count="' + targetCount + '"]').clone().appendTo(charmsPreview);
          charmsPrice = charmsPrice + (parseFloat(target.attr('data-price')) || 0);
          const count = charmsPreview.find('.constructor-result-charm').length;
          charmsPreview.removeClass('constructor-result-charms-1 constructor-result-charms-2 constructor-result-charms-3');
          charmsPreview.addClass('constructor-result-charms-' + count);
        }
      }

      renderPrice();

      if (selectedCharmsCount) {
        step2NextBtn.removeAttr('disabled');
      } else {
        step2NextBtn.attr('disabled', 'disabled');
      }
    }

    function addTocart() {
      const items = [];
      const selectedChain = selectedChainVariantId
        ? chainItems.filter('[data-variant-id="' + selectedChainVariantId + '"]').first()
        : chainItems.filter('.constructor-choice-item_active').first();

      const chain = {
        id: selectedChainVariantId || selectedChain.attr('data-variant-id'),
        quantity: 1,
      };

      if (selectedChain.attr('data-preorder') === 'true') {
        chain.properties = {
          'Order type': 'Pre-order',
        };
      }

      items.push(chain);

      const charms = charmsPreview.find('.constructor-result-charm');
      charms.each(function () {
        items.push({
          id: $(this).attr('data-variant-id'),
          quantity: 1,
        });
      });

      $root.addClass('constructor-loading');

      fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
        body: JSON.stringify({ items: items }),
      })
        .then(function (response) {
          if (!response.ok) {
            throw new Error('Error adding product to cart');
          }
          return response.json();
        })
        .then(function () {
          const finalCharms = $root.find('.constructor-result-final .constructor-result-charms');
          finalCharms.empty();
          charmsPreview.find('.constructor-result-charm').clone().appendTo(finalCharms);
          finalCharms.removeClass('constructor-result-charms-1 constructor-result-charms-2 constructor-result-charms-3');
          const finalCharmCount = finalCharms.find('.constructor-result-charm').length;
          if (finalCharmCount > 0) {
            finalCharms.addClass('constructor-result-charms-' + finalCharmCount);
          }
          showStep(3);
          $root.removeClass('constructor-loading');
        })
        .catch(function (error) {
          console.error('Error:', error);
          $root.removeClass('constructor-loading');
        });
    }

    function changePic() {
      const pics = currentPic.closest('.constructor-choice-item-pics');
      if (!pics.length) return;
      const altPic = pics.find('.constructor-choice-item-pic-alt');
      const mainPic = pics.find('.constructor-choice-item-pic-main');
      if (altPic.css('display') === 'none') {
        altPic.css('display', 'block');
        mainPic.css('display', 'none');
      } else {
        altPic.css('display', 'none');
        mainPic.css('display', 'block');
      }
      const dots = pics.closest('.constructor-choice-item-pic-wrapper').find('.constructor-choice-item-dots-dot');
      dots.toggleClass('constructor-choice-item-dots-dot_active');
    }

    let currentPic;

    startButton.on('click', function () {
      showStep(1);
    });
    step1NextBtn.on('click', function () {
      showStep(2);
    });
    step2BackBtns.on('click', function () {
      showStep(1);
    });
    step2NextBtn.on('click', function () {
      addTocart();
    });
    chainItems.on('click', changeCurrentChain);
    charmsItems.on('click', changeCurrentCharm);

    let touchMoved = false;

    $root.find('.constructor-choice-item-alt-pic').on('touchstart', function (e) {
      touchMoved = false;
      currentPic = $(e.target);
    });

    $root.find('.constructor-choice-item-alt-pic').on('touchmove', function () {
      touchMoved = true;
    });

    $root.find('.constructor-choice-item-alt-pic').on('touchend', function () {
      if (touchMoved) {
        changePic();
      }
    });

    ensureValidChainSelection();
  }

  $('.js-constructor-root').each(function () {
    initConstructor(this);
  });
});
